<div class="page-container content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <p class="headerName">{{ headerData.materialName }}</p>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'disabled-project': isScreenDisabled }">
    <div>
      <div class="" [ngClass]="{ 'disabled-project': checkboxValue }">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <piqet-angular-portlet
            *ngIf="sharedData.dataLoaded"
            [class]="'detail-cell-renderer'"
            [columnDefs]="columnDefs"
            [frameworkComponents]="frameworkComponents"
            [headerBtn]="consumerList?.consumerList?.length >= 1 ? '' : 'Add consumer'"
            [createAccess]="showEdit"
            [gridData]="consumerList?.consumerList"
            [class]="'fixedHeight'"
            [searchInputSize]="true"
            [pageNo]="$any(consumerList?.consumerList)?.draw"
            [hidePagination]="true"
            [hideSearch]="true"
            (openBtnModal)="addCustomConversion(scenarioId, 0, 3, 'Add consumer')"
            [gridName]="gridName"
            [hideSideBar]="isHideSideBar"
            [isClearSearch]="sharedData.isClearSearch"
          ></piqet-angular-portlet>
        </div>
      </div>
    </div>
  </div>
  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>
